export enum SECTION_REPORT_CODE {
    QUALITY_ASSURANCE = '60-18-14-11',
    LOGISTIC_SUPPORT = '60-18-00-13',
    BUSINESS_PROCESS = '60-18-14-12',
    SPECIAL_SERVICES = '60-18-15-13'
}